// extracted by mini-css-extract-plugin
export default {"error_cont":"error_error_cont__g4gXC","error_text":"error_error_text__YbAYS","btn":"error_btn__9s2cd"};